<div class="procurement-scope-wrapper" appUserManual [userManualKey]="'procurement-package-selection'">
  <div class="procurement-package-table">
    <p-floatlabel variant="in" class="package-filter-field">
      <p-iconfield>
        <input pInputText id="package-filter" [(ngModel)]="packageFilterText" placeholder="Number or name" />
        <p-inputicon *ngIf="packageFilterText" class="pi pi-times clear-filter-icon" aria-label="Clear filter" (click)="packageFilterText = ''" />
      </p-iconfield>
      <label for="package-filter">Filter packages</label>
    </p-floatlabel>

    <p-accordion [multiple]="true" [(value)]="expandedPackageIds">
      <p-accordion-panel *ngFor="let procurementPackage of filteredProcurementPackages" [value]="procurementPackage.id">
        <p-accordion-header>
          <div class="package-header">
            <p-checkbox
              [binary]="true"
              (click)="$event.stopPropagation()"
              (onChange)="onSelectPackage(procurementPackage, $event.checked)"
              [ngModel]="isPackageSelected(procurementPackage)"
            />
            <span class="package-number">{{ procurementPackage.number }}</span>
            <span class="package-name">{{ procurementPackage.name }}</span>
          </div>
          <div class="package-header-meta">
            <span class="package-assigned-pill" [ngClass]="getPackageAssignedPillClass(procurementPackage)">
              <i class="pill-icon pi" [ngClass]="getPackageAssignedIcon(procurementPackage) === 'group' ? 'pi-users' : 'pi-exclamation-triangle'"></i>
              <span class="pill-text">{{ getPackageAssignedLabel(procurementPackage) }}</span>
            </span>
            <span class="po-count-badge">{{ procurementPackage.purchaseOrders?.length || 0 }} POs</span>
          </div>
        </p-accordion-header>

        <p-accordion-content>
          <div class="package-vendors" *ngIf="procurementPackage?.connectedVendors?.length">
          <app-vendor-pill
            *ngFor="let vendor of procurementPackage.connectedVendors"
            [vendor]="vendor"
            (usersChanged)="onVendorUsersChanged($event)"
          ></app-vendor-pill>
        </div>
        <div class="package-vendors" *ngIf="!procurementPackage?.connectedVendors?.length">
          <div class="vendor-pill pill-error">No vendors</div>
        </div>

        <div class="purchase-orders-list" *ngIf="procurementPackage.purchaseOrders?.length">
          <h4 class="po-section-title">Purchase Orders</h4>
          <div class="po-card" *ngFor="let po of procurementPackage.purchaseOrders">
            <div class="po-card-header">
              <span class="po-number">{{ po.number }}</span>
              <span class="po-name">{{ po.name }}</span>
            </div>
            <div class="po-card-details">
              <div class="po-vendor" *ngIf="po.vendor">
                <i class="po-detail-icon pi pi-building"></i>
                <span>{{ po.vendor.name }} ({{ po.vendor.number }})</span>
              </div>
            </div>
            <div class="po-note" *ngIf="po.note">
              <p>{{ po.note | slice:0:150 }}{{ po.note.length > 150 ? '...' : '' }}</p>
            </div>
          </div>
        </div>
          <div class="no-purchase-orders" *ngIf="!procurementPackage.purchaseOrders?.length">
            <em>No purchase orders</em>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>

  <div class="csa-table" appUserManual [userManualKey]="'procurement-package-scope-of-work'">
    <div *ngIf="selectedProcurementPackages.length > 0">
      <h3>Available scope of work</h3>

      <div class="filter">
        <span>Filter:</span>
        <div class="filter-field-wrapper">
          <p-floatlabel variant="in" class="filter-field">
            <p-iconfield>
              <input pInputText id="assignment-filter" [(ngModel)]="filterText" (keyup)="onFilterKeyup()" placeholder="Tag / Checksheet / Package / ID" />
              <p-inputicon *ngIf="filterText" class="pi pi-times clear-filter-icon" aria-label="Clear filter" (click)="clearFilter()" />
            </p-iconfield>
            <label for="assignment-filter">Filter</label>
          </p-floatlabel>

          <div class="sow-filter-actions">
            <span class="toggle-text" *ngIf="hideUnassigned">Unassigned only</span>
            <span class="toggle-text" *ngIf="!hideUnassigned">All items</span>
            <button
              type="button"
              pButton
              class="sow-toggle-btn"
              (click)="toggleHideUnassigned()"
              [attr.aria-pressed]="hideUnassigned"
              [attr.aria-label]="
                hideUnassigned
                  ? 'Showing only unassigned checksheets. Click to show all.'
                  : 'Showing all checksheets. Click to show only unassigned.'
              "
              [pTooltip]="hideUnassigned ? 'Unassigned only (click to show all)' : 'Show only unassigned'"
              tooltipPosition="top"
            >
              <i [class]="hideUnassigned ? 'pi pi-filter' : 'pi pi-filter-slash'"></i>
            </button>
          </div>
        </div>
      </div>

      <p-table [value]="filteredAvailableCheckSheetAssignments" dataKey="id" [scrollable]="true" scrollHeight="calc(100vh - 420px)" styleClass="assignment-table">
        <ng-template #header>
          <tr>
            <th><p-checkbox [binary]="true" [ngModel]="allAssignmentsSelected" (onChange)="onSelectAllAssignments($event.checked)" /></th>
            <th pSortableColumn="procurementPackageNumber" primeColumnFilter="procurementPackageNumber" [primeFilterData]="availableCheckSheetAssignments" (primeFilterChange)="onAssignmentColumnFilter('procurementPackageNumber', $event)">PackageNo <p-sortIcon field="procurementPackageNumber" /></th>
            <th pSortableColumn="mcPackageNumber" primeColumnFilter="mcPackageNumber" [primeFilterData]="availableCheckSheetAssignments" (primeFilterChange)="onAssignmentColumnFilter('mcPackageNumber', $event)">McNumber <p-sortIcon field="mcPackageNumber" /></th>
            <th pSortableColumn="tagNumber" primeColumnFilter="tagNumber" [primeFilterData]="availableCheckSheetAssignments" (primeFilterChange)="onAssignmentColumnFilter('tagNumber', $event)">Tag <p-sortIcon field="tagNumber" /></th>
            <th pSortableColumn="companyNumber" primeColumnFilter="companyNumber" [primeFilterData]="availableCheckSheetAssignments" (primeFilterChange)="onAssignmentColumnFilter('companyNumber', $event)">Company <p-sortIcon field="companyNumber" /></th>
            <th pSortableColumn="checkSheetNumber" primeColumnFilter="checkSheetNumber" [primeFilterData]="availableCheckSheetAssignments" (primeFilterChange)="onAssignmentColumnFilter('checkSheetNumber', $event)">Check sheet <p-sortIcon field="checkSheetNumber" /></th>
            <th pSortableColumn="status" primeColumnFilter="status" [primeFilterData]="availableCheckSheetAssignments" (primeFilterChange)="onAssignmentColumnFilter('status', $event)">Status <p-sortIcon field="status" /></th>
            <th>Assigned</th>
          </tr>
        </ng-template>
        <ng-template #body let-assignment>
          <tr>
            <td><p-checkbox [binary]="true" [ngModel]="isAssignmentSelected(assignment)" (onChange)="onSelectAssignment(assignment, $event.checked)" /></td>
            <td>{{ assignment.procurementPackageNumber }}</td><td>{{ assignment.mcPackageNumber }}</td><td>{{ assignment.tagNumber }}</td><td>{{ assignment.companyNumber }}</td><td>{{ assignment.checkSheetNumber }}</td><td>{{ assignment.status }}</td>
            <td>
            <span class="assigned-pill" [ngClass]="getAssignedCountPillClass(assignment)">
              {{ getAssignedCountLabel(assignment) }}
            </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
